import VALIDATE_RESET_PASSWORD_TOKEN from '../../graphql/reset-password/validateResetPasswordToken.gql';
import RESET_PASSWORD from '../../graphql/reset-password/resetPassword.gql';
import {apolloClient} from "../../plugins/apollo-client";

const validateResetPasswordToken = (token) =>
  apolloClient
    .mutate({
      mutation: VALIDATE_RESET_PASSWORD_TOKEN,
      variables: {
        token
      },
      fetchPolicy: 'no-cache'
    })
    .then(({data}) => data);

const resetPassword = (token, password, repeatPassword, gRecaptcha) =>
  apolloClient
    .mutate({
      mutation: RESET_PASSWORD,
      variables: {
        password,
        repeatPassword,
        token,
        gRecaptcha
      },
      fetchPolicy: 'no-cache'
    })
    .then(({data}) => data);

export {
  validateResetPasswordToken,
  resetPassword
}
